module.exports = __webpack_public_path__ + "webpc/img/icon_gz_3.9f290b03.png";